export const unitServiceTableConfig = [
  {
    name: "mechanicName",
    label: "Tim Mekanik",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
    },
  },
  {
    name: "lastMonth",
    label: "Last Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "thisMonth",
    label: "This Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "growth",
    label: "Growth (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "projection",
    label: "Proyeksi",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "productivityLastMonth",
    label: "Productivity/Day Last Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "productivityThisMonth",
    label: "Productivity/Day This Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];

export const unitEntriTableConfig = [
  {
    name: "timMekanik",
    label: "Tim Mekanik",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
    },
  },
  {
    name: "lastMonth",
    label: "Last Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "thisMonth",
    label: "This Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "growth",
    label: "Growth (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "proyeksi",
    label: "Proyeksi",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "productivityLastMonth",
    label: "Productivity/Day Last Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
  {
    name: "productivityThisMonth",
    label: "Productivity/Day This Month",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "20%", minWidth: "20%", textAlign: "center" },
      }),
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  },
];
